import React, {useEffect, useRef, useState} from "react";
import {RowJobTable} from "../../../types/adminPageTypes";
import {getJobsTableData} from "../../../queries/adminPageQueries";
import RestartJobTable from "./RestartJobTable";
import Box from "@mui/material/Box";
import {JobsTableColumns, rowsJobsTablePageSize} from "../../../utils/constants"
import ErrorSnackBar from "../../CommonComponents/ErrorSnackBar/ErrorSnackBar";
import StyledCheckBoxLabel from "../../CommonComponents/StyledCheckbox/StyledCheckBoxLabel";
import {useTheme} from "../../../contexts/theme";

const pageSize = rowsJobsTablePageSize;
const checkBoxDim = '30px'

export default function RestartJobTableWrapper() {

    const theme = useTheme()

    const [dataTable,setDataTable] = useState<RowJobTable[]>([])
    const rowsRef = useRef<RowJobTable[]>([])
    const [page,setPage] = useState<number>(0)
    const [tableLoading, setTableLoading] = useState<boolean>(true)
    const [includeRunningJobs, setIncludeRunningJobs] = useState<boolean>(false)
    const firstLoadRef = useRef<boolean>(true)

    const [errorMessage, setErrorMessage] = useState<{error: boolean, message: string}>({error:false, message: "",})

    function getDataForTable () {
        setTableLoading(true);
        getJobsTableData(page, pageSize, includeRunningJobs)
            .then(dataJobs => {
                setDataTable(dataJobs);
                setTableLoading(false);
                firstLoadRef.current = false;
            }).catch(e => {
                setTableLoading(false);
                setErrorMessage({error:true, message:"Error fetching Jobs infos"});
        })
    }

    useEffect(() => {
        getDataForTable()
    }, []);

    useEffect(() => {
        if(!firstLoadRef.current){
            getDataForTable()
        }
    }, [page]);

    const handlePage = (page: number) => {
        setPage(page);
    }

    function onJobStop(jobId: string) {
        const tempDataTable = [...rowsRef.current]
        const job = tempDataTable.find(job => job.id === jobId);
        if (job){
            job.status = "Cancelled"
            setDataTable(tempDataTable)
        }
    }

    function onIncludeRunningJobsChange(event: any) {
        const checked = event.target.checked
        setIncludeRunningJobs(checked)
    }

    useEffect(() => {
        if(!firstLoadRef.current){
            getDataForTable()
        }
    }, [includeRunningJobs]);

    useEffect(() => {
        rowsRef.current = dataTable
    }, [dataTable]);

    return (
        <Box
            style={{
                width: "100%",
                height: "100%",
                justifyContent: 'space-between',
            }}
        >
            <ErrorSnackBar
                autoHideDuration={2000}
                open={errorMessage.error}
                setClose={()=>{setErrorMessage({error: false, message: ""})}}
                errorMessage={errorMessage.message}
            />
            <Box marginTop={theme.spacing.sm} marginBottom={theme.spacing.sm}>
                <StyledCheckBoxLabel
                    width={checkBoxDim}
                    height={checkBoxDim}
                    iconSize={checkBoxDim}
                    label={"Include Running Jobs"}
                    checked={includeRunningJobs}
                    onChange={onIncludeRunningJobsChange}/>
            </Box>
            <RestartJobTable
                columns={JobsTableColumns}
                rows={dataTable}
                loading={tableLoading}
                page={page}
                handlePage={handlePage}
                onJobStop={onJobStop}
            />
    </Box>

    )
}